var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.87 70.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #4c4c4c;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.19,11.22c3.62-.45,7.52,2.43,8.58,5.81,2.3,7.3-5.06,13.32-11.96,10.02-1.51-.72-2.02-2.02-4.07-1.61-.58.12-4.84,2.28-5.4,2.7-2.27,1.73-.88,3.49-.97,5.81-.11,2.81-1.94,4.3.85,6.57,3.31,2.69,3.84.6,6.68-.65,10.84-4.8,20.42,8.37,12.47,17-6.47,7.02-18.56,2.42-18.72-7.08-.04-2.25,1.51-3.73-.66-5.79-3.75-3.55-5.54.25-8.82,1.5-7.02,2.67-15.05-.84-17.27-8.08-3.58-11.61,8.73-21.19,19.21-15,2.41,1.42,3.03,3.65,6.26,2.81.65-.17,5.14-2.75,5.5-3.24.94-1.3.48-2.92.78-4.39.6-2.9,4.69-6.02,7.55-6.37Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.f9661ba894d69e27f1f1db09afff9ac7.svg";
export { ForwardRef as ReactComponent };